import './index.css';

document.querySelectorAll('.obp-password-field__toggle').forEach((toggle) => {
  const input = toggle.closest('.obp-password-field')?.querySelector('input');
  if (!input) return;

  toggle.addEventListener('click', () => {
    const isVisible = input.type === 'text';
    input.type = isVisible ? 'password' : 'text';
    toggle.setAttribute('aria-pressed', String(!isVisible));
    toggle.setAttribute('aria-label', isVisible ? 'Show password' : 'Hide password');
  });
});
